import { render, staticRenderFns } from "./edit-user-blocks.vue?vue&type=template&id=6872f67c&scoped=true&"
import script from "./edit-user-blocks.vue?vue&type=script&lang=js&"
export * from "./edit-user-blocks.vue?vue&type=script&lang=js&"
import style0 from "./edit-user-blocks.vue?vue&type=style&index=0&id=6872f67c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6872f67c",
  null
  
)

export default component.exports